import Nullstack from 'nullstack';
export default function IconArrowsDoubleNwSe({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-double-nw-se",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 21l-11 -11"
  }), "   ", Nullstack.element("path", {
    d: "M3 14v-4h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 14h4v-4"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "3",
    x2: "21",
    y2: "14"
  }), " ");
}